export const tableTokens = {
  'table-header-bg': 'var(--dp-color-primary)',
  'table-header-text': 'var(--dp-color-text-inverse)',
  'table-header-font-weight': 'var(--dp-font-weight-semibold)',
  'table-header-font-size': 'var(--dp-font-size-sm)',
  'table-row-bg': 'var(--dp-color-background)',
  'table-row-bg-hover': 'var(--dp-color-surface-hover)',
  'table-row-bg-striped': 'var(--dp-color-surface)',
  'table-border-color': 'var(--dp-color-border)',
  'table-cell-padding-x': 'var(--dp-spacing-md)',
  'table-cell-padding-y': 'var(--dp-spacing-sm)',
  'table-border-radius': 'var(--dp-border-radius-md)',
} as const;
